<svg width="18" height="12" viewBox="0 0 18 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9 0L17.6603 12H0.339746L9 0Z" fill="white" />
</svg>